import { createContext, useContext, useState, useEffect } from 'react';

// 翻译文件
const translations = {
  zh: {
    // Header
    header: {
      home: '首页',
      lpMining: 'LP挖矿',
      tokenMining: '代币挖矿',
      referral: '推荐奖励',
      admin: '管理',
      switchNetwork: '切换网络',
      connecting: '连接中...',
      connectWallet: '连接钱包',
    },
    // HomePage
    home: {
      badge: 'BSC 链上 DeFi 协议 · 安全可靠',
      title1: '质押挖矿',
      title2: '轻松赚取收益',
      subtitle: 'LP 挖矿 + 代币挖矿 + 推荐奖励 + 团队奖励',
      totalReward: '总计 1 亿 AGG 代币奖励',
      startMining: '开始挖矿',
      inviteFriends: '邀请好友',
      lpPoolStaked: 'LP 矿池总质押',
      tokenPoolStaked: '代币矿池质押',
      lpDistributed: 'LP 已分发奖励',
      maxApy: '代币最高年化',
      chooseMethod: '选择你的',
      miningMethod: '挖矿方式',
      moreChannels: '多种收益渠道，灵活组合，最大化你的收益',
      lpMiningTitle: 'LP 质押挖矿',
      lpMiningSubtitle: '70% 代币分配',
      lpMiningDesc: '质押 LP 代币参与挖矿，享受 65% 收益直接到账，3年线性释放',
      lpMiningStats: '7000万 AGG',
      tokenMiningTitle: '代币质押挖矿 V2',
      tokenMiningSubtitle: '30% 代币分配',
      tokenMiningDesc: '多档锁仓，收益更高！灵活质押146% APY，12个月锁仓365% APY',
      tokenMiningStats: '3000万 AGG',
      referralTitle: '三级推荐奖励',
      referralSubtitle: '最高 35% 额外收益',
      referralDesc: '邀请好友参与挖矿，1代20%、2代10%、3代5% 推荐奖励',
      referralStats: '无限邀请',
      teamTitle: '团队极差奖励',
      teamSubtitle: '最高 2% 网体收益',
      teamDesc: '根据团队小区业绩获得极差奖励，等级越高收益越多',
      teamStats: '3级等级',
      learnMore: '了解详情',
      tokenDistribution: '代币分配方案',
      lpMiningAlloc: 'LP 质押挖矿',
      tokenMiningAlloc: '代币质押挖矿',
    },
    // LP Mining Page
    lpMining: {
      title: 'LP 质押挖矿',
      subtitle: '质押 LP 代币，赚取挖矿奖励',
      lockDays: '锁仓',
      days: '天',
      locked: '锁仓中',
      remaining: '剩余时间',
      totalStaked: '总质押量',
      remainingRewards: '剩余奖励',
      remainingTime: '剩余时间',
      distributed: '已分发',
      miningProgress: '挖矿进度',
      stakeLp: '质押 LP',
      availableBalance: '可用余额',
      enterAmount: '输入质押数量',
      pleaseConnect: '请先连接钱包',
      approveLp: '授权 LP 代币',
      approving: '授权中...',
      staking: '质押中...',
      stake: '质押',
      lockResetWarning: '锁仓期重置提醒',
      lockResetDesc: '您当前有',
      inLockup: '在锁仓中，剩余',
      newStakeWillReset: '新增质押将',
      resetLockPeriod: '重置锁仓期',
      to: '为',
      myStaking: '我的质押',
      stakedAmount: '已质押数量',
      enterWithdrawAmount: '输入解押数量',
      unstaking: '解押中...',
      unstake: '解押',
      myRewards: '我的收益',
      pendingRewards: '待领取收益',
      claiming: '领取中...',
      claimRewards: '领取收益',
      totalClaimed: '累计已领取',
      referralRewards: '推荐奖励',
      teamRewards: '团队奖励',
      rewardDetails: '收益分配详情 & 团队信息',
      referralRates: '推荐奖励比例',
      level1Referrer: '1代推荐人',
      level2Referrer: '2代推荐人',
      level3Referrer: '3代推荐人',
      teamLevelThreshold: '团队等级阈值',
      level: '等级',
      currentConfig: '当前合约配置',
      totalRewards: '总奖励',
      miningPeriod: '挖矿周期',
      year: '年',
      lockDuration: '锁仓天数',
      myTeamInfo: '我的团队信息',
      directReferrals: '直推人数',
      teamPerformance: '团队业绩',
      smallAreaPerformance: '小区业绩',
      teamLevel: '团队等级',
      unlocked: '已解锁',
      // Admin panel
      adminPanel: '管理员配置面板',
      lockDaysSetting: '锁仓天数',
      currentLockDays: '当前',
      enterDays: '输入天数',
      set: '设置',
      miningParams: '挖矿参数',
      totalRewardAmount: '总奖励数量',
      miningPeriodYears: '挖矿周期（年）',
      setMiningParams: '设置挖矿参数',
      distributionRates: '分配比例',
      distributionRatesDesc: '两者之和必须等于100%',
      userShare: '用户占比%',
      splitShare: '分流占比%',
      setDistributionRates: '设置分配比例',
      referralRatesSetting: '推荐奖励比例',
      level1Percent: '1代%',
      level2Percent: '2代%',
      level3Percent: '3代%',
      setReferralRates: '设置推荐比例',
      lpTransfer: 'LP转移',
      contractLpBalance: '合约LP余额',
      lpTransferWarning: '警告：此功能可转移合约中的任意LP（包括用户质押的LP），请谨慎操作！',
      receiverAddress: '接收地址',
      transferAmount: '转移数量',
      transferring: '转移中...',
      transferLp: '转移LP',
    },
    // Token Mining Page
    tokenMining: {
      title: '代币质押挖矿 V2',
      subtitle: '多档锁仓，收益更高',
      inProgress: '进行中',
      ended: '已结束',
      miningEndedTitle: '挖矿已结束',
      miningEndedDesc: '奖励池已耗尽，无法进行新的质押。您仍可以提取已质押的本金和已产生的收益。',
      flexible: '随进随出',
      months3: '3个月',
      months6: '6个月',
      months12: '12个月',
      dailyRate: '日收益',
      lockDays: '锁仓',
      days: '天',
      totalStaked: '总质押量',
      distributedRewards: '已分发奖励',
      remainingRewards: '剩余奖励',
      myPending: '我的待领取',
      rewardProgress: '奖励发放进度',
      stakeToken: '质押代币',
      selectedTier: '选择的档位',
      annualYield: '年化收益',
      lockPeriod: '锁仓期',
      afterExpiry: '到期后可提取本金',
      availableBalance: '可用余额',
      enterAmount: '输入质押数量',
      estimatedDaily: '预计每日收益',
      estimatedMonthly: '预计月收益',
      pleaseConnect: '请先连接钱包',
      approveToken: '授权 AGG 代币',
      approving: '授权中...',
      staking: '质押中...',
      stakingRules: '多档质押规则：',
      rule1: '随进随出：',
      rule1Desc: '/天，随时可取',
      rule2: '3个月锁仓：',
      rule2Desc: '/天，90天后可取',
      rule3: '6个月锁仓：',
      rule3Desc: '/天，180天后可取',
      rule4: '12个月锁仓：',
      rule4Desc: '/天，365天后可取',
      slippageWarning: '滑点提醒',
      slippageDesc1: 'AGG 代币在 DEX 卖出时有',
      slippageDesc2: '滑点（买入 0%）。质押和领取收益不受滑点影响。',
      myStakes: '我的质押',
      claimAll: '一键领取全部',
      claiming: '领取中...',
      totalStakedUser: '总质押',
      totalEarned: '累计收益',
      noStakes: '暂无质押记录',
      startStaking: '选择档位并质押代币开始赚取收益',
      remaining: '剩余:',
      unlocked: '已解锁',
      claimReward: '领取收益',
      withdrawPrincipal: '提取本金',
      inLockup: '锁仓中',
      withdrawing: '提取中...',
      calculator: '收益计算器',
      stakeAmount: '质押数量',
      daily: '日',
      monthly: '月',
      // Phase labels
      phaseB: 'Phase B',
      phaseBBadge: '进行中',
      phaseA: 'Phase A',
      phaseABadge: '已结束',
      phaseADesc: 'Phase A 已结束，仅可提取本金和领取已产生的收益。',
      showV2: '展开 Phase A',
      hideV2: '收起 Phase A',
      // Referral system
      referralSection: '推荐系统',
      myReferralLink: '我的推荐链接',
      copyLink: '复制链接',
      copied: '已复制',
      setReferrer: '设置推荐人',
      referrerBound: '当前推荐人',
      directReferrals: '直推人数',
      referralRates: '推荐比例',
      pendingReferralReward: '待领取推荐奖励',
      referralRewardHint: '推荐奖励在您推荐的用户领取挖矿收益时自动产生',
      claimReferralReward: '领取推荐奖励',
      claimingReferral: '领取中...',
      myTeam: '我的团队',
      totalReferralClaimed: '已领取推荐奖励',
      enterReferrerAddress: '输入推荐人地址 (0x...)',
      settingReferrer: '设置中...',
      referrerTip: '温馨提示',
      referrerTipDesc: '任何有效地址都可以作为推荐人，设置后不可更改。',
      noReferrer: '未设置推荐人',
      person: '人',
      level: '代',
      loadMore: '加载更多',
      noTeamMembers: '暂无团队成员',
      v2TotalStaked: 'V2总质押',
      v2TotalClaimed: 'V2已领取',
    },
    // Referral Page
    referral: {
      title: '推荐奖励',
      subtitle: '邀请好友，共享收益',
      maxBonus: '最高 35% 额外收益',
      myReferralLink: '我的专属推荐链接',
      shareLinkDesc: '分享链接邀请好友参与挖矿，获得三级推荐奖励',
      copied: '已复制',
      copyLink: '复制链接',
      directReferrals: '直推人数',
      teamPerformance: '团队业绩',
      smallAreaPerformance: '小区业绩',
      teamLevel: '团队等级',
      level: '级',
      person: '人',
      myReferrer: '我的推荐人',
      referrerAddress: '推荐人地址',
      view: '查看',
      setReferrerDesc: '设置推荐人后，您的推荐人将获得您挖矿收益的推荐奖励',
      referrerTip: '温馨提示',
      referrerTipDesc: '任何有效的钱包地址都可以作为您的推荐人，设置后无法更改，请确认地址正确。',
      enterReferrerAddress: '输入推荐人地址 (0x...)',
      settingReferrer: '设置中...',
      setReferrer: '设置推荐人',
      referralReward: '推荐奖励',
      pendingReferralReward: '待领取推荐奖励',
      referralRewardHint: '推荐奖励在您推荐的用户领取挖矿收益时自动产生',
      claiming: '领取中...',
      claimReferralReward: '领取推荐奖励',
      teamReward: '团队奖励',
      achieved: '已达成',
      need: '需',
      rewardRate: '奖励比例',
      pendingTeamReward: '待领取团队奖励',
      claimTeamReward: '领取团队奖励',
      myTeam: '我的团队',
      total: '共',
      personL1: '人 (1代)',
      personTotal: '人',
      refresh: '刷新',
      all: '全部',
      level1: '1代',
      level2: '2代',
      level3: '3代',
      level1Members: '1代会员',
      level2Members: '2代会员',
      level3Members: '3代会员',
      deeperLevels: '更深层级',
      loadingTeam: '加载团队数据...',
      noTeamMembers: '暂无团队成员',
      shareYourLink: '分享您的推荐链接邀请好友',
      superior: '上级',
      grandSuperior: '上上级',
      loadMore: '加载更多',
      bindTwoTxTip: '绑定推荐人需要确认2笔交易（LP挖矿和代币挖矿各1笔）',
      rewardRules: '奖励规则说明',
      referralRewardTitle: '推荐奖励 (从35%奖励池分配)',
      level1Rate: '总收益的 7%',
      level2Rate: '总收益的 3.5%',
      level3Rate: '总收益的 1.75%',
      teamRewardTitle: '团队奖励 (极差制)',
      teamRule1: '根据小区业绩确定您的团队等级',
      teamRule2: '上级只获得与下级的等级差额奖励（极差制）',
      teamRule3: '最高可获得',
      teamRule3b: '网体收益',
    },
    // Admin Page
    admin: {
      title: '管理员控制台',
      subtitle: '合约参数配置与管理',
      refreshData: '刷新数据',
      warning: '管理员操作注意事项',
      warningDesc: '修改合约参数会影响所有用户，请谨慎操作。部分参数修改后无法撤销。',
      owner: 'Owner',
      nonOwner: 'Non-Owner',
      currentConfig: '当前配置',
      lockPeriod: '锁仓期',
      days: '天',
      totalRewards: '总奖励',
      userSplit: '用户/分成',
      referralRates: '推荐比例',
      lockPeriodSetting: '锁仓期设置',
      lockDays: '锁仓天数',
      save: '保存',
      miningParams: '挖矿参数',
      totalRewardAmount: '总奖励 (AGG)',
      miningDuration: '挖矿时长 (年)',
      saveMiningParams: '保存挖矿参数',
      distributionRates: '分配比例 (总和 = 100%)',
      userRate: '用户比例 %',
      splitRate: '分成比例 %',
      saveDistributionRates: '保存分配比例',
      referralRatesSetting: '推荐比例',
      level1: '1代 %',
      level2: '2代 %',
      level3: '3代 %',
      saveReferralRates: '保存推荐比例',
      splitAddressConfig: '分流地址配置 (35% 池分配)',
      splitAddressDesc: '配置收益分流地址和比例。总比例应等于 100%。',
      currentConfigLabel: '当前配置:',
      address: '地址',
      saveSplitConfig: '保存分流配置',
      teamLevelConfig: '团队等级配置 (极差奖励)',
      teamLevelDesc: '配置团队等级的业绩阈值和对应奖励比例。',
      threshold: '阈值 (LP)',
      level: '等级',
      saveTeamLevelConfig: '保存团队等级配置',
      totalStaked: '总质押',
      distributed: '已分发',
      remainingRewards: '剩余奖励',
      status: '状态',
      inProgress: '进行中',
      ended: '已结束',
      tierRates: '档位费率',
      flexible: '随进随出',
      months3: '3个月',
      months6: '6个月',
      months12: '12个月',
      daily: '每日',
      totalRewardsSetting: '总奖励设置',
      totalRewardAmount2: '总奖励数量 (AGG)',
      noteLarger: '注意：新值必须大于已分发数量',
      tierRateSetting: '档位费率设置 (每日百分比)',
      flexibleLock: '随进随出',
      months3Lock: '3个月锁仓',
      months6Lock: '6个月锁仓',
      months12Lock: '12个月锁仓',
      eg: '如:',
      noteMaxRate: '注意：费率最高不超过 10% (1000 basis points)',
      slippageSetting: '滑点设置 (买入/卖出)',
      buySlippage: '买入滑点 %',
      sellSlippage: '卖出滑点 %',
      saveSlippageSetting: '保存滑点设置',
      maxSlippage: '最高 10%，当前: 买入 0% / 卖出 2.8%',
      pairSetting: '交易对设置',
      pairAddress: '交易对合约地址 (0x...)',
      add: '添加',
      pairDesc: '添加交易对后，用户向该地址转账（卖出）将收取滑点',
      currentPair: '当前交易对:',
      feeReceiver: '手续费接收地址',
      receiverAddress: '接收地址 (0x...)',
      set: '设置',
      whitelist: '白名单管理 (免滑点)',
      walletAddress: '钱包地址 (0x...)',
      remove: '移除',
      whitelistDesc: '白名单地址在买卖时不收取滑点费用',
      pleaseConnect: '请先连接钱包',
      loading: '加载中...',
      verifyingAdmin: '正在验证管理员权限',
      noAccess: '无权访问',
      notOwner: '当前钱包不是任何合约的 Owner',
      debugInfo: '调试信息:',
      connectedAddress: '连接地址:',
      lpMiningOwner: 'LP Mining Owner:',
      tokenMiningV2Owner: 'TokenMiningV2 Owner:',
      projectTokenV2Owner: 'ProjectTokenV2 Owner:',
      notLoaded: '未加载',
      notSet: '未设置',
      addLevel: '添加代数',
      removeLevel: '删除代数',
      referralRatesV3Desc: '设置 TokenMiningV3 的推荐奖励比例，支持 1-20 代推荐。比例值为百分比。',
      referralRatesV3Note: '注意：保存后将覆盖所有现有推荐代数设置。',
    },
    // App (Referrer Modal)
    app: {
      bindReferrer: '绑定推荐人',
      viaReferralLink: '您是通过推荐链接访问的',
      referrerAddress: '推荐人地址',
      bindReferrerDesc: '绑定推荐人后，您的挖矿收益将为推荐人带来奖励分成。',
      irreversible: '此操作不可撤销',
      confirmCorrect: '请确认推荐人地址正确。',
      cancel: '取消',
      binding: '绑定中...',
      confirmBind: '确认绑定',
      bindTwoTxNote: '绑定推荐人需要在钱包中确认1笔交易。',
    },
    // Common
    common: {
      connectWallet: '请先连接钱包',
      loading: '加载中...',
      copied: '已复制',
      success: '成功',
      error: '失败',
      confirm: '确认',
      cancel: '取消',
      save: '保存',
      LP: 'LP',
      AGG: 'AGG',
    },
    // Footer
    footer: {
      builtOn: 'Built on BSC.',
      lpMiningContract: 'LP Mining Contract',
      tokenMiningContract: 'Token Mining Contract',
    },
    // Toast messages
    toast: {
      cannotReferSelf: '不能推荐自己',
      bindingReferrer: '正在绑定推荐人...',
      bindSuccess: '推荐人绑定成功！',
      bindFailed: '绑定失败，请稍后重试',
      approving: '授权中...',
      approveSuccess: '授权成功',
      staking: '质押中...',
      stakeSuccess: '质押成功',
      withdrawing: '提取中...',
      withdrawSuccess: '提取成功',
      claiming: '领取中...',
      claimSuccess: '领取成功',
      claimingAll: '领取全部收益中...',
      unstaking: '解押中...',
      unstakeSuccess: '解押成功',
      referralLinkCopied: '推荐链接已复制',
      settingReferrer: '设置推荐人中...',
      setReferrerSuccess: '推荐人设置成功',
      bindNeedTwoTx: '请在钱包中确认交易...',
      invalidAddress: '无效的地址格式',
      claimingReferral: '领取推荐奖励中...',
      claimingTeam: '领取团队奖励中...',
      // Admin toast messages
      settingLockPeriod: '设置锁仓期...',
      lockPeriodSuccess: '锁仓期设置成功',
      settingParams: '设置挖矿参数...',
      paramsSuccess: '挖矿参数设置成功',
      settingDistribution: '设置分配比例...',
      distributionSuccess: '分配比例设置成功',
      settingReferralRates: '设置推荐比例...',
      referralRatesSuccess: '推荐比例设置成功',
      settingSplitAddresses: '设置分流地址...',
      splitAddressesSuccess: '分流地址设置成功',
      settingTeamLevels: '设置团队等级...',
      teamLevelsSuccess: '团队等级设置成功',
      settingTotalRewards: '设置总奖励...',
      totalRewardsSuccess: '总奖励设置成功',
      settingTierRate: '设置档位费率...',
      tierRateSuccess: '档位费率设置成功',
      settingFees: '设置滑点...',
      feesSuccess: '滑点设置成功',
      settingPair: '设置交易对...',
      pairSuccess: '交易对设置成功',
      addingWhitelist: '添加白名单...',
      removingWhitelist: '移除白名单...',
      whitelistAdded: '已添加白名单',
      whitelistRemoved: '已移除白名单',
      settingFeeReceiver: '设置手续费接收地址...',
      feeReceiverSuccess: '手续费接收地址设置成功',
      settingFailed: '设置失败',
      operationFailed: '操作失败',
      fillValidAddress: '请至少填写一个有效地址',
      fillValidRate: '请至少填写一个有效比例',
      fillLevelConfig: '请至少填写一个等级配置',
      addressCopied: '已复制地址',
      transferring: '转移中...',
      transferSuccess: 'LP转移成功',
      transferFailed: '转移失败',
    },
  },
  en: {
    // Header
    header: {
      home: 'Home',
      lpMining: 'LP Mining',
      tokenMining: 'Token Mining',
      referral: 'Referral',
      admin: 'Admin',
      switchNetwork: 'Switch Network',
      connecting: 'Connecting...',
      connectWallet: 'Connect Wallet',
    },
    // HomePage
    home: {
      badge: 'BSC DeFi Protocol · Safe & Reliable',
      title1: 'Stake Mining',
      title2: 'Earn Rewards Easily',
      subtitle: 'LP Mining + Token Mining + Referral Rewards + Team Rewards',
      totalReward: 'Total 100 Million AGG Token Rewards',
      startMining: 'Start Mining',
      inviteFriends: 'Invite Friends',
      lpPoolStaked: 'LP Pool Total Staked',
      tokenPoolStaked: 'Token Pool Staked',
      lpDistributed: 'LP Distributed Rewards',
      maxApy: 'Max Token APY',
      chooseMethod: 'Choose Your',
      miningMethod: 'Mining Method',
      moreChannels: 'Multiple earning channels, flexible combinations, maximize your returns',
      lpMiningTitle: 'LP Staking Mining',
      lpMiningSubtitle: '70% Token Allocation',
      lpMiningDesc: 'Stake LP tokens to mine, enjoy 65% returns directly, 3-year linear release',
      lpMiningStats: '70M AGG',
      tokenMiningTitle: 'Token Staking Mining V2',
      tokenMiningSubtitle: '30% Token Allocation',
      tokenMiningDesc: 'Multi-tier lockup, higher yields! Flexible 146% APY, 12-month lock 365% APY',
      tokenMiningStats: '30M AGG',
      referralTitle: '3-Level Referral Rewards',
      referralSubtitle: 'Up to 35% Extra Earnings',
      referralDesc: 'Invite friends to mine, Level 1: 20%, Level 2: 10%, Level 3: 5% rewards',
      referralStats: 'Unlimited',
      teamTitle: 'Team Differential Rewards',
      teamSubtitle: 'Up to 2% Network Earnings',
      teamDesc: 'Earn differential rewards based on team performance, higher level = more rewards',
      teamStats: '3 Levels',
      learnMore: 'Learn More',
      tokenDistribution: 'Token Distribution Plan',
      lpMiningAlloc: 'LP Staking Mining',
      tokenMiningAlloc: 'Token Staking Mining',
    },
    // LP Mining Page
    lpMining: {
      title: 'LP Staking Mining',
      subtitle: 'Stake LP tokens, earn mining rewards',
      lockDays: 'Lock',
      days: 'days',
      locked: 'Locked',
      remaining: 'Remaining',
      totalStaked: 'Total Staked',
      remainingRewards: 'Remaining Rewards',
      remainingTime: 'Time Remaining',
      distributed: 'Distributed',
      miningProgress: 'Mining Progress',
      stakeLp: 'Stake LP',
      availableBalance: 'Available Balance',
      enterAmount: 'Enter stake amount',
      pleaseConnect: 'Please connect wallet first',
      approveLp: 'Approve LP Token',
      approving: 'Approving...',
      staking: 'Staking...',
      stake: 'Stake',
      lockResetWarning: 'Lock Period Reset Warning',
      lockResetDesc: 'You currently have',
      inLockup: 'in lockup, remaining',
      newStakeWillReset: 'New stake will',
      resetLockPeriod: 'reset lock period',
      to: 'to',
      myStaking: 'My Staking',
      stakedAmount: 'Staked Amount',
      enterWithdrawAmount: 'Enter withdraw amount',
      unstaking: 'Unstaking...',
      unstake: 'Unstake',
      myRewards: 'My Rewards',
      pendingRewards: 'Pending Rewards',
      claiming: 'Claiming...',
      claimRewards: 'Claim Rewards',
      totalClaimed: 'Total Claimed',
      referralRewards: 'Referral Rewards',
      teamRewards: 'Team Rewards',
      rewardDetails: 'Reward Details & Team Info',
      referralRates: 'Referral Reward Rates',
      level1Referrer: 'Level 1 Referrer',
      level2Referrer: 'Level 2 Referrer',
      level3Referrer: 'Level 3 Referrer',
      teamLevelThreshold: 'Team Level Threshold',
      level: 'Level',
      currentConfig: 'Current Contract Config',
      totalRewards: 'Total Rewards',
      miningPeriod: 'Mining Period',
      year: 'year',
      lockDuration: 'Lock Duration',
      myTeamInfo: 'My Team Info',
      directReferrals: 'Direct Referrals',
      teamPerformance: 'Team Performance',
      smallAreaPerformance: 'Small Area Performance',
      teamLevel: 'Team Level',
      unlocked: 'Unlocked',
      // Admin panel
      adminPanel: 'Admin Config Panel',
      lockDaysSetting: 'Lock Days',
      currentLockDays: 'Current',
      enterDays: 'Enter days',
      set: 'Set',
      miningParams: 'Mining Parameters',
      totalRewardAmount: 'Total Rewards',
      miningPeriodYears: 'Mining Period (years)',
      setMiningParams: 'Set Mining Params',
      distributionRates: 'Distribution Rates',
      distributionRatesDesc: 'Sum must equal 100%',
      userShare: 'User Share %',
      splitShare: 'Split Share %',
      setDistributionRates: 'Set Distribution Rates',
      referralRatesSetting: 'Referral Reward Rates',
      level1Percent: 'L1 %',
      level2Percent: 'L2 %',
      level3Percent: 'L3 %',
      setReferralRates: 'Set Referral Rates',
      lpTransfer: 'LP Transfer',
      contractLpBalance: 'Contract LP Balance',
      lpTransferWarning: 'Warning: This function can transfer any LP in the contract (including user staked LP). Please operate carefully!',
      receiverAddress: 'Receiver Address',
      transferAmount: 'Transfer Amount',
      transferring: 'Transferring...',
      transferLp: 'Transfer LP',
    },
    // Token Mining Page
    tokenMining: {
      title: 'Token Staking Mining V2',
      subtitle: 'Multi-tier lockup, higher yields',
      inProgress: 'In Progress',
      ended: 'Ended',
      miningEndedTitle: 'Mining Ended',
      miningEndedDesc: 'Reward pool is exhausted, no new stakes allowed. You can still withdraw your principal and earned rewards.',
      flexible: 'Flexible',
      months3: '3 Months',
      months6: '6 Months',
      months12: '12 Months',
      dailyRate: 'Daily Rate',
      lockDays: 'Lock',
      days: 'days',
      totalStaked: 'Total Staked',
      distributedRewards: 'Distributed Rewards',
      remainingRewards: 'Remaining Rewards',
      myPending: 'My Pending',
      rewardProgress: 'Reward Distribution Progress',
      stakeToken: 'Stake Token',
      selectedTier: 'Selected Tier',
      annualYield: 'Annual Yield',
      lockPeriod: 'Lock Period',
      afterExpiry: 'Principal withdrawable after expiry',
      availableBalance: 'Available Balance',
      enterAmount: 'Enter stake amount',
      estimatedDaily: 'Estimated Daily Earnings',
      estimatedMonthly: 'Estimated Monthly Earnings',
      pleaseConnect: 'Please connect wallet first',
      approveToken: 'Approve AGG Token',
      approving: 'Approving...',
      staking: 'Staking...',
      stakingRules: 'Multi-tier Staking Rules:',
      rule1: 'Flexible:',
      rule1Desc: '/day, withdraw anytime',
      rule2: '3-Month Lock:',
      rule2Desc: '/day, withdraw after 90 days',
      rule3: '6-Month Lock:',
      rule3Desc: '/day, withdraw after 180 days',
      rule4: '12-Month Lock:',
      rule4Desc: '/day, withdraw after 365 days',
      slippageWarning: 'Slippage Notice',
      slippageDesc1: 'AGG token has',
      slippageDesc2: 'slippage when selling on DEX (0% buy). Staking and claiming are not affected.',
      myStakes: 'My Stakes',
      claimAll: 'Claim All',
      claiming: 'Claiming...',
      totalStakedUser: 'Total Staked',
      totalEarned: 'Total Earned',
      noStakes: 'No stakes yet',
      startStaking: 'Select a tier and stake tokens to start earning',
      remaining: 'Remaining:',
      unlocked: 'Unlocked',
      claimReward: 'Claim Reward',
      withdrawPrincipal: 'Withdraw Principal',
      inLockup: 'Locked',
      withdrawing: 'Withdrawing...',
      calculator: 'Earnings Calculator',
      stakeAmount: 'Stake Amount',
      daily: 'Daily',
      monthly: 'Monthly',
      // Phase labels
      phaseB: 'Phase B',
      phaseBBadge: 'In Progress',
      phaseA: 'Phase A',
      phaseABadge: 'Ended',
      phaseADesc: 'Phase A has ended. You can only withdraw principal and claim earned rewards.',
      showV2: 'Show Phase A',
      hideV2: 'Hide Phase A',
      // Referral system
      referralSection: 'Referral System',
      myReferralLink: 'My Referral Link',
      copyLink: 'Copy Link',
      copied: 'Copied',
      setReferrer: 'Set Referrer',
      referrerBound: 'Current Referrer',
      directReferrals: 'Direct Referrals',
      referralRates: 'Referral Rates',
      pendingReferralReward: 'Pending Referral Reward',
      referralRewardHint: 'Referral rewards are generated when your referrals claim mining rewards',
      claimReferralReward: 'Claim Referral Reward',
      claimingReferral: 'Claiming...',
      myTeam: 'My Team',
      totalReferralClaimed: 'Total Referral Claimed',
      enterReferrerAddress: 'Enter referrer address (0x...)',
      settingReferrer: 'Setting...',
      referrerTip: 'Tip',
      referrerTipDesc: 'Any valid address can be your referrer. Once set, it cannot be changed.',
      noReferrer: 'No referrer set',
      person: '',
      level: 'Level',
      loadMore: 'Load More',
      noTeamMembers: 'No team members yet',
      v2TotalStaked: 'V2 Total Staked',
      v2TotalClaimed: 'V2 Total Claimed',
    },
    // Referral Page
    referral: {
      title: 'Referral Rewards',
      subtitle: 'Invite friends, share earnings',
      maxBonus: 'Up to 35% Extra Earnings',
      myReferralLink: 'My Referral Link',
      shareLinkDesc: 'Share your link to invite friends to mine and earn 3-level referral rewards',
      copied: 'Copied',
      copyLink: 'Copy Link',
      directReferrals: 'Direct Referrals',
      teamPerformance: 'Team Performance',
      smallAreaPerformance: 'Small Area Performance',
      teamLevel: 'Team Level',
      level: 'Level',
      person: '',
      myReferrer: 'My Referrer',
      referrerAddress: 'Referrer Address',
      view: 'View',
      setReferrerDesc: 'After setting a referrer, they will receive referral rewards from your mining earnings',
      referrerTip: 'Tip',
      referrerTipDesc: 'Any valid wallet address can be your referrer. Once set, it cannot be changed. Please confirm the address is correct.',
      enterReferrerAddress: 'Enter referrer address (0x...)',
      settingReferrer: 'Setting...',
      setReferrer: 'Set Referrer',
      referralReward: 'Referral Reward',
      pendingReferralReward: 'Pending Referral Reward',
      referralRewardHint: 'Referral rewards are generated when your referrals claim mining rewards',
      claiming: 'Claiming...',
      claimReferralReward: 'Claim Referral Reward',
      teamReward: 'Team Reward',
      achieved: 'Achieved',
      need: 'Need',
      rewardRate: 'Reward Rate',
      pendingTeamReward: 'Pending Team Reward',
      claimTeamReward: 'Claim Team Reward',
      myTeam: 'My Team',
      total: 'Total',
      personL1: '(Level 1)',
      personTotal: '',
      refresh: 'Refresh',
      all: 'All',
      level1: 'L1',
      level2: 'L2',
      level3: 'L3',
      level1Members: 'Level 1 Members',
      level2Members: 'Level 2 Members',
      level3Members: 'Level 3 Members',
      deeperLevels: 'Deeper Levels',
      loadingTeam: 'Loading team data...',
      noTeamMembers: 'No team members yet',
      shareYourLink: 'Share your referral link to invite friends',
      superior: 'Superior',
      grandSuperior: 'Grand Superior',
      loadMore: 'Load More',
      bindTwoTxTip: 'Binding a referrer requires confirming 2 transactions (1 for LP Mining and 1 for Token Mining)',
      rewardRules: 'Reward Rules',
      referralRewardTitle: 'Referral Rewards (from 35% pool)',
      level1Rate: '7% of total',
      level2Rate: '3.5% of total',
      level3Rate: '1.75% of total',
      teamRewardTitle: 'Team Rewards (Differential)',
      teamRule1: 'Your team level is determined by small area performance',
      teamRule2: 'Superiors only receive differential rewards from lower levels',
      teamRule3: 'Maximum',
      teamRule3b: 'network earnings',
    },
    // Admin Page
    admin: {
      title: 'Admin Console',
      subtitle: 'Contract parameter configuration',
      refreshData: 'Refresh Data',
      warning: 'Admin Operation Notice',
      warningDesc: 'Modifying contract parameters affects all users. Please operate carefully. Some changes cannot be reversed.',
      owner: 'Owner',
      nonOwner: 'Non-Owner',
      currentConfig: 'Current Config',
      lockPeriod: 'Lock Period',
      days: 'days',
      totalRewards: 'Total Rewards',
      userSplit: 'User/Split',
      referralRates: 'Referral Rates',
      lockPeriodSetting: 'Lock Period Setting',
      lockDays: 'Lock Days',
      save: 'Save',
      miningParams: 'Mining Parameters',
      totalRewardAmount: 'Total Rewards (AGG)',
      miningDuration: 'Mining Duration (years)',
      saveMiningParams: 'Save Mining Params',
      distributionRates: 'Distribution Rates (Sum = 100%)',
      userRate: 'User Rate %',
      splitRate: 'Split Rate %',
      saveDistributionRates: 'Save Distribution Rates',
      referralRatesSetting: 'Referral Rates',
      level1: 'L1 %',
      level2: 'L2 %',
      level3: 'L3 %',
      saveReferralRates: 'Save Referral Rates',
      splitAddressConfig: 'Split Address Config (35% Pool)',
      splitAddressDesc: 'Configure split addresses and rates. Total should equal 100%.',
      currentConfigLabel: 'Current Config:',
      address: 'Address',
      saveSplitConfig: 'Save Split Config',
      teamLevelConfig: 'Team Level Config (Differential)',
      teamLevelDesc: 'Configure team level thresholds and reward rates.',
      threshold: 'Threshold (LP)',
      level: 'Level',
      saveTeamLevelConfig: 'Save Team Level Config',
      totalStaked: 'Total Staked',
      distributed: 'Distributed',
      remainingRewards: 'Remaining Rewards',
      status: 'Status',
      inProgress: 'In Progress',
      ended: 'Ended',
      tierRates: 'Tier Rates',
      flexible: 'Flexible',
      months3: '3 Months',
      months6: '6 Months',
      months12: '12 Months',
      daily: 'Daily',
      totalRewardsSetting: 'Total Rewards Setting',
      totalRewardAmount2: 'Total Reward Amount (AGG)',
      noteLarger: 'Note: New value must be greater than distributed amount',
      tierRateSetting: 'Tier Rate Setting (Daily %)',
      flexibleLock: 'Flexible',
      months3Lock: '3-Month Lock',
      months6Lock: '6-Month Lock',
      months12Lock: '12-Month Lock',
      eg: 'e.g.',
      noteMaxRate: 'Note: Max rate is 10% (1000 basis points)',
      slippageSetting: 'Slippage Setting (Buy/Sell)',
      buySlippage: 'Buy Slippage %',
      sellSlippage: 'Sell Slippage %',
      saveSlippageSetting: 'Save Slippage Setting',
      maxSlippage: 'Max 10%, Current: Buy 0% / Sell 2.8%',
      pairSetting: 'Trading Pair Setting',
      pairAddress: 'Pair Contract Address (0x...)',
      add: 'Add',
      pairDesc: 'After adding pair, transfers to this address (sell) will incur slippage',
      currentPair: 'Current Pair:',
      feeReceiver: 'Fee Receiver Address',
      receiverAddress: 'Receiver Address (0x...)',
      set: 'Set',
      whitelist: 'Whitelist Management (No Slippage)',
      walletAddress: 'Wallet Address (0x...)',
      remove: 'Remove',
      whitelistDesc: 'Whitelisted addresses are exempt from slippage fees',
      pleaseConnect: 'Please connect wallet first',
      loading: 'Loading...',
      verifyingAdmin: 'Verifying admin permissions',
      noAccess: 'Access Denied',
      notOwner: 'Current wallet is not owner of any contract',
      debugInfo: 'Debug Info:',
      connectedAddress: 'Connected Address:',
      lpMiningOwner: 'LP Mining Owner:',
      tokenMiningV2Owner: 'TokenMiningV2 Owner:',
      projectTokenV2Owner: 'ProjectTokenV2 Owner:',
      notLoaded: 'Not Loaded',
      notSet: 'Not Set',
      addLevel: 'Add Level',
      removeLevel: 'Remove Level',
      referralRatesV3Desc: 'Set TokenMiningV3 referral reward rates. Supports 1-20 levels. Values are percentages.',
      referralRatesV3Note: 'Note: Saving will overwrite all existing referral level settings.',
    },
    // App (Referrer Modal)
    app: {
      bindReferrer: 'Bind Referrer',
      viaReferralLink: 'You came via a referral link',
      referrerAddress: 'Referrer Address',
      bindReferrerDesc: 'After binding a referrer, your mining earnings will generate rewards for them.',
      irreversible: 'This action is irreversible',
      confirmCorrect: ', please confirm the referrer address is correct.',
      cancel: 'Cancel',
      binding: 'Binding...',
      confirmBind: 'Confirm Bind',
      bindTwoTxNote: 'Binding a referrer requires confirming 1 transaction in your wallet.',
    },
    // Common
    common: {
      connectWallet: 'Please connect wallet first',
      loading: 'Loading...',
      copied: 'Copied',
      success: 'Success',
      error: 'Failed',
      confirm: 'Confirm',
      cancel: 'Cancel',
      save: 'Save',
      LP: 'LP',
      AGG: 'AGG',
    },
    // Footer
    footer: {
      builtOn: 'Built on BSC.',
      lpMiningContract: 'LP Mining Contract',
      tokenMiningContract: 'Token Mining Contract',
    },
    // Toast messages
    toast: {
      cannotReferSelf: 'Cannot refer yourself',
      bindingReferrer: 'Binding referrer...',
      bindSuccess: 'Referrer bound successfully!',
      bindFailed: 'Binding failed, please try again',
      approving: 'Approving...',
      approveSuccess: 'Approved successfully',
      staking: 'Staking...',
      stakeSuccess: 'Staked successfully',
      withdrawing: 'Withdrawing...',
      withdrawSuccess: 'Withdrawn successfully',
      claiming: 'Claiming...',
      claimSuccess: 'Claimed successfully',
      claimingAll: 'Claiming all rewards...',
      unstaking: 'Unstaking...',
      unstakeSuccess: 'Unstaked successfully',
      referralLinkCopied: 'Referral link copied',
      settingReferrer: 'Setting referrer...',
      setReferrerSuccess: 'Referrer set successfully',
      bindNeedTwoTx: 'Please confirm the transaction in your wallet...',
      invalidAddress: 'Invalid address format',
      claimingReferral: 'Claiming referral rewards...',
      claimingTeam: 'Claiming team rewards...',
      // Admin toast messages
      settingLockPeriod: 'Setting lock period...',
      lockPeriodSuccess: 'Lock period set successfully',
      settingParams: 'Setting mining params...',
      paramsSuccess: 'Mining params set successfully',
      settingDistribution: 'Setting distribution rates...',
      distributionSuccess: 'Distribution rates set successfully',
      settingReferralRates: 'Setting referral rates...',
      referralRatesSuccess: 'Referral rates set successfully',
      settingSplitAddresses: 'Setting split addresses...',
      splitAddressesSuccess: 'Split addresses set successfully',
      settingTeamLevels: 'Setting team levels...',
      teamLevelsSuccess: 'Team levels set successfully',
      settingTotalRewards: 'Setting total rewards...',
      totalRewardsSuccess: 'Total rewards set successfully',
      settingTierRate: 'Setting tier rate...',
      tierRateSuccess: 'Tier rate set successfully',
      settingFees: 'Setting fees...',
      feesSuccess: 'Fees set successfully',
      settingPair: 'Setting pair...',
      pairSuccess: 'Pair set successfully',
      addingWhitelist: 'Adding to whitelist...',
      removingWhitelist: 'Removing from whitelist...',
      whitelistAdded: 'Added to whitelist',
      whitelistRemoved: 'Removed from whitelist',
      settingFeeReceiver: 'Setting fee receiver...',
      feeReceiverSuccess: 'Fee receiver set successfully',
      settingFailed: 'Setting failed',
      operationFailed: 'Operation failed',
      fillValidAddress: 'Please fill at least one valid address',
      fillValidRate: 'Please fill at least one valid rate',
      fillLevelConfig: 'Please fill at least one level config',
      addressCopied: 'Address copied',
      transferring: 'Transferring...',
      transferSuccess: 'LP transferred successfully',
      transferFailed: 'Transfer failed',
    },
  },
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    // 从 localStorage 读取或使用浏览器语言
    const saved = localStorage.getItem('language');
    if (saved && (saved === 'zh' || saved === 'en')) {
      return saved;
    }
    // 检测浏览器语言
    const browserLang = navigator.language.toLowerCase();
    return browserLang.startsWith('zh') ? 'zh' : 'en';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'zh' ? 'en' : 'zh');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
